// extracted by mini-css-extract-plugin
export default {"airplaneSizingContainer":"kva-z","narrowOptionButtons":"lva-z","noOptions":"mva-z"};